enum Features {
  BROADCAST_BANNER = 'Broadcast Banner',
  DYNAMIC_HEADER = 'Dynamic Header',
  GIFT_SHARING = 'Gift Sharing',
  EDD_PANEL = 'EDD Panel',
  SMS_NOTIFICATIONS = 'Notification Center',
  EMAIL_NOTIFICATIONS = 'Email Notifications',
  DELIVERY_NOTIFICATIONS = 'Delivery Notifications',
  BLOCK_ASSET = 'Block Asset',
  NARVAR_FOOTER = 'Narvar Footer',
  FEEDBACK = 'Feedback',
  HELP_PILL = 'Help Pill',
  SECTION_DIVIDER = 'Section Divider',
  DELIVERY_INSTRUCTIONS = 'Delivery Instructions',
  SCHEDULED_DELIVERY = 'Scheduled Delivery',
  REDIRECT_TO_HOLD = 'Redirect to Hold',
  PICKUP_POINT_DETAILS = 'Pickup Point Details',
  PRODUCT_RECOMMENDATIONS = 'Product Recommendations',
  YOUTUBE = 'YouTube',
  ITEMS_IN_THIS_SHIPMENT = 'Items in This Shipment',
  MORE_INFORMATION = 'More Information',
  PICKUP_LOCATION = 'Pickup Location',
  SHIPMENTS = 'Shipments',
  EMPTY = 'Empty',
  CUSTOM_COMPONENT = 'Custom Component',
  DELIVERY_STATUS = 'Delivery Status',
  DELIVERY_MAP = 'Delivery Map',
  DRIVER_DETAILS = 'Driver Details',
}

export default Features;
